<template>
	<v-row dense class="px-3 py-1 app-bar-borders">
		<v-col cols="12" v-if="$route.path === '/dashboard'">
			<v-alert height="40" dense type="error" color="#D90808" class="mb-0">
				<v-row>
					<v-col class="text-left" align-self="center"> Patient John Doe is having SI thoughts! </v-col>
					<v-col class="shrink">
						<v-btn
							:height="33"
							color="white"
							style="background-color: white; color: black; margin-top: -4.5px; margin-right: -12px">
							{{ $t('resolve') }}
						</v-btn>
					</v-col>
				</v-row>
			</v-alert>
		</v-col>
		<v-col
			cols="2"
			v-if="
				[
					'/organizations',
					'/inventoryConsumables',
					'/inventoryItems',
					'/consumableCatalog',
					'/itemCatalog',
					'/licenses',
					'/logs',
					'/invoices',
					'/dashboardsystemadmin',
					'/sareports',
					'/offices',
					'/admins',
					'/verifier',
					'/organizationMapping',
					'/locationMapping',
					'/organizationMappingPcc',
					'/pccLocationMapping',
				].includes($route.path)
			"
			style="min-width: 200px">
			<v-text-field
				class="width-text-field1"
				prepend-inner-icon="mdi-magnify"
				hide-details
				dense
				v-model="search"
				:label="$t('search')"
				outlined />
		</v-col>
		<v-col cols="2" v-if="$route.path === '/dashboardsystemadmin'" class="ml-auto">
			<v-menu
				v-model="menu1"
				:close-on-content-click="false"
				:nudge-right="-90"
				offset-y
				min-width="auto"
				style="z-index: 1000">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						v-model="selectedDateForSystemAdmin"
						label="Filter date"
						readonly
						v-bind="attrs"
						single-line
						hide-details
						prepend-inner-icon="mdi-calendar"
						dense
						v-on="on"
						outlined />
				</template>
				<v-date-picker
					:disabled="!enableDatePicker"
					v-model="selectedDateForSystemAdmin"
					color="primary"
					type="month"
					no-title
					scrollable
					@change="menu1 = false" />
			</v-menu>
		</v-col>
		<v-col cols="2" v-if="$route.path === '/logs'" class="ml-auto">
			<v-menu
				v-model="menu1"
				:close-on-content-click="false"
				:nudge-right="-90"
				offset-y
				min-width="auto"
				style="z-index: 1000">
				<template v-slot:activator="{ on, attrs }">
					<v-text-field
						v-model="selectedDateForLogs"
						label="Filter date"
						readonly
						v-bind="attrs"
						single-line
						hide-details
						prepend-inner-icon="mdi-calendar"
						dense
						v-on="on"
						outlined />
				</template>
				<v-date-picker
					v-model="selectedDateForLogs"
					color="primary"
					type="date"
					no-title
					scrollable
					@change="menu1 = false"
					:max="new Date().toISOString().slice(0, 10)" />
			</v-menu>
		</v-col>
		<v-col cols="2" v-if="['/sareports', '/admins', '/inventoryConsumables', '/inventoryItems'].includes($route.path)">
			<v-select
				class="width-text-field2"
				hide-details
				dense
				v-model="selectedMedicalInstitution"
				:items="medicalInstitutions"
				item-value="id"
				item-text="institutionName"
				:label="$t('medicalInstitution')"
				outlined
				:menu-props="{ offsetY: true }">
			</v-select>
		</v-col>
		<v-col cols="2" v-if="['/offices', '/residentMapping', '/medicalStaffMapping'].includes($route.path)">
			<v-select
				class="width-text-field2"
				hide-details
				dense
				v-model="selectedMedicalInstitution"
				:items="medicalInstitutions?.slice(1) || []"
				item-value="id"
				item-text="institutionName"
				:label="$t('medicalInstitution')"
				outlined
				:menu-props="{ offsetY: true }" />
		</v-col>
		<v-col
			cols="2"
			v-if="
				['/inventoryItems', '/inventoryConsumables', '/residentMapping', '/medicalStaffMapping'].includes($route.path)
			">
			<v-combobox
				class="width-text-field2"
				hide-details="auto"
				dense
				v-model="selectedHospital"
				:items="filteredHospitals"
				item-value="id"
				item-text="hospitalName"
				:label="$t('hospital')"
				outlined
				:menu-props="{ offsetY: true }">
				<template #selection="{ item }"> {{ item === -99 ? '' : item.hospitalName }} </template>
			</v-combobox>
		</v-col>
		<v-col cols="2" v-if="$route.path === '/admins'">
			<v-select
				class="width-text-field2"
				hide-details
				dense
				v-model="selectedUserStatusVerifier"
				:items="userStatusVerifiers"
				item-value="lowValue"
				item-text="shortDescription"
				:label="$t('status')"
				outlined
				:menu-props="{ offsetY: true }">
			</v-select>
		</v-col>
		<v-col cols="2" v-if="$route.path === '/licenses'">
			<v-select
				class="width-text-field2"
				hide-details
				dense
				v-model="selectedLicensesVerifiers"
				:items="licenseStatuses"
				item-value="lowValue"
				:item-text="$i18n.locale === 'en' ? 'shortDescription' : 'shortDescriptionEsp'"
				:label="$t('licenses')"
				outlined
				:menu-props="{ offsetY: true }">
			</v-select>
		</v-col>
		<v-col cols="2" v-if="$route.path === '/admins'">
			<v-select
				class="width-text-field2"
				hide-details
				dense
				v-model="selectedRole"
				:items="filteredRoles"
				item-value="id"
				item-text="roleNameForDisplay"
				:label="$t('role')"
				outlined
				:menu-props="{ offsetY: true }">
			</v-select>
		</v-col>
		<v-spacer />
		<v-col v-if="$route.path === '/support'" class="py-5" />
		<v-col
			class="text-right"
			align-self="center"
			v-if="
				[
					'/invoices',
					'/verifier',
					'/licenses',
					'/organizationMapping',
					'/organizationMappingPcc',
					'/locationMapping',
					'/pccLocationMapping',
					'/itemCatalog',
					'/consumableCatalog',
					'/inventoryItems',
					'/inventoryConsumables',
					'/device-template',
					'/offices',
					'/admins',
					'/organizations',
				].includes($route.path)
			">
			<v-btn @click="synchronizeDrawers" color="chips" variant="tonal" prepend-icon="mdi-plus">
				<img class="me-3" height="15" :src="addWhite" />
				<span class="text-capitalize text-color-white">{{ $t(pathname) }}</span>
			</v-btn>
		</v-col>
	</v-row>
</template>

<script>
import { addWhite } from '@/assets';
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
	name: 'DashboardCoreDrawer',
	components: {},
	props: {
		expandOnHover: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		addWhite: addWhite,
		items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
		search: null,
		selectedHospital: -99,
		surgery: -1,
		selectedMedicalInstitution: -1,
		selectedUserStatusVerifier: null,
		selectedLicensesVerifiers: null,
		selectedRole: -99,
		menu1: false,
		selectedDateForSystemAdmin: new Date().toISOString().substr(0, 7),
		selectedDateForLogs: new Date().toISOString().substr(0, 10),
	}),

	async mounted () {
		await this.getAllHospitals();
		await this.getMedicalInstitutions(); // get the list once, after that we use it from the shared state
		await this.getAllVerifiers(); // get the list once, after that we use it from the shared state
		await this.getAllRoles(); // get the list once, after that we use it from the shared state
	},
	computed: {
		...mapState({
			allVerifiers: (state) => state.verifiers.allverifires,
			allRoles: (state) => state.roles.roles,
			enableDatePicker: (state) => state.filterbar.enableDatePicker,
			hospitals: (state) => state.hospitals.hospitals,
		}),
		...mapGetters({
			// roles: 'roles/getRoles',
			getSpecializations: 'verifiers/getSpecializations',
			medicalInstitutions: 'medicalInstitutions/getMedicalInstitutionsSorted',
			getMedicalTeam: 'filterbar/getMedicalTeam',
		}),
		pathname () {
			return this.$route.name;
		},
		drawer: {
			get () {
				return this.$store.state.drawer;
			},
			set (val) {
				this.$store.commit('SET_DETAILS_DRAWER', val);
			},
		},
		detailsDrawer () {
			return this.$store.state.detailsDrawer;
		},
		userStatusVerifiers () {
			let userStatusVerifiersList =
				this.allVerifiers != null
					? this.allVerifiers.filter((v) => v.rvDomain === 'USER_STATUS' && v.lowValue !== 99)
					: null;
			if (userStatusVerifiersList != null) {
				userStatusVerifiersList.unshift({ lowValue: -99, shortDescription: 'All', shortDescriptionEsp: 'Todo' });
			} else {
				userStatusVerifiersList = [];
				userStatusVerifiersList.unshift({ lowValue: -99, shortDescription: 'All', shortDescriptionEsp: 'Todo' });
			}
			return userStatusVerifiersList;
		},
		licenseStatuses () {
			return [
				{ lowValue: null, shortDescription: 'All', shortDescriptionEsp: 'Todo' },
				{ lowValue: true, shortDescription: 'Active', shortDescriptionEsp: 'Activo' },
				{ lowValue: false, shortDescription: 'Inactive', shortDescriptionEsp: 'Inactivo' },
			];
		},
		filteredRoles () {
			const fileteredRolesList =
				this.allRoles != null
					? this.allRoles.filter(
							(r) =>
								r.roleName === 'HOSPITAL_ADMIN' || r.roleName === 'ORGANIZATION_ADMIN' || r.id === 9 || r.id === 10,
					  )
					: [];
			fileteredRolesList.unshift({ id: -99, roleNameForDisplay: 'All', shortDescriptionEsp: 'Toda' });
			return fileteredRolesList;
		},
		filteredHospitals () {
			let calculatedFilteredHospital = this.hospitals || [];
			if (this.selectedMedicalInstitution !== null && this.selectedMedicalInstitution !== 0) {
				calculatedFilteredHospital = calculatedFilteredHospital.filter(
					(h) => h.medicalInstitutionId === this.selectedMedicalInstitution,
				);
			} else {
				calculatedFilteredHospital = this.hospitals;
			}
			return calculatedFilteredHospital;
		},
	},

	methods: {
		...mapMutations({
			setDrawer: 'SET_DETAILS_DRAWER',
		}),
		// handlePatientMapping () {
		//   // Call API HERE , and send the information about the orgazniation and hospital.
		//   this.$store.dispatch();
		// },
		async getMedicalInstitutions () {
			await this.$store.dispatch('medicalInstitutions/getMedicalInstitutions').then(() => {
				// this.medicalInstitutions = this.medicalInstitutionsFromRepo;
			});
		},
		async getAllHospitals () {
			// we call this API endpoint only if the store values are null
			if (this.hospitals == null) {
				await this.$store.dispatch('hospitals/getHospitals').then(() => {
					// this.loading = false;
				});
			}
		},
		async getAllVerifiers () {
			// we call this API endpoint only if the store values are null
			if (this.allVerifiers == null) {
				await this.$store.dispatch('verifiers/getAllVerifiers').then(() => {
					// this.loading = false;
				});
			}
		},
		async getAllRoles () {
			// we call this API endpoint only if the store values are null
			if (this.allRoles == null) {
				await this.$store.dispatch('roles/getRoles').then(() => {
					// this.loading = false;
				});
			}
		},
		synchronizeDrawers () {
			const pages = [
				'medical staff',
				'patients',
				'medical team',
				'assessments',
				'verifier',
				'organization',
				'office',
				'admins',
				'invoices',
				'licenses',
				'organization mapping',
				'location mapping',
				'pointclickcare organization mapping',
				'pointclickcare location mapping',
				'item catalog',
				'consumable catalog',
				'inventory items',
				'inventory consumables',
				'device template',
			];
			const page = this.pathname.toLowerCase();
			if (pages.includes(page)) {
				this.$store.commit('SET_DETAILS_DRAWER', {
					detailsDrawer: true,
					page,
				});
			}
		},
	},
	watch: {
		async selectedHospital (val) {
			if (val?.id === undefined || val?.id === null) {
				this.selectedHospital = -99;
			} else {
				await this.$store.dispatch('filterbar/selectedHospital', val.id);
			}
		},
		async selectedDateForSystemAdmin (val) {
			await this.$store.dispatch('filterbar/SystemAdminDate', val);
		},
		async selectedDateForLogs (val) {
			await this.$store.dispatch('filterbar/selectedLogsDate', val);
		},
		async surgery (val) {
			await this.$store.dispatch('filterbar/AppBarSpacialization', val);
		},
		async doctor (val) {
			await this.$store.dispatch('filterbar/AppBarMedicalTeamDoctor', val);
		},
		async search (val) {
			await this.$store.dispatch('filterbar/AppBarSearch', val);
		},
		async selectedMedicalInstitution (val) {
			if (val === 0 && this.hospitals[0].id !== 0) {
				this.hospitals.unshift({ id: -99, hospitalName: 'All' });
				if (this.$i18n.locale === 'es') this.hospitals[0].hospitalName = 'Todo';
			}
			await this.$store.dispatch('filterbar/AppBarMedicalInstitution', val);
		},
		async selectedUserStatusVerifier (val) {
			await this.$store.dispatch('filterbar/AppBarUserStatusVerifier', val);
		},
		async selectedLicensesVerifiers (val) {
			await this.$store.dispatch('filterbar/AppBarLicenseStatusVerifier', val);
		},
		async selectedRole (val) {
			await this.$store.dispatch('filterbar/AppBarRole', val);
		},
		$route (to, from) {
			if (to.path === '/offices') {
				this.selectedMedicalInstitution = null;
				this.selectedHospital = null;
			}
			if (to.path !== from.path) {
				this.search = null;
				// this.selectedMedicalInstitution = -1;
				// this.selectedHospital = null;
			}
		},
	},
};
</script>
